import React from 'react';
import '../UploadForm.css';

function KeywordAddInput({ value, onChange, onAdd }) {
  return (
    <div className="keyword-edit-tools">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onAdd && onAdd();
        }}
        placeholder="Add missing keyword..."
        className="keyword-add-input"
      />
      <button onClick={onAdd} className="keyword-add-button" disabled={!value.trim()}>
        Add
      </button>
    </div>
  );
}

export default KeywordAddInput;


